import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 6);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-600">
              最受欢迎的约炮技巧与经验分享
            </p>
          </div>
          <Link
            to="/category/yuepao-jiqiao"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="featured" />
          ))}
        </div>
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/yuepao-jiqiao"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}